import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '~/lib/api';
import { useMe } from '~/hooks/use-auth';
import { LANGUAGE_CODES, type LanguageCode } from '~shared/i18n/languages';

/**
 * Язык сообщений участнику (localization): пока участник вошёл, отправляет на сервер текущий язык
 * лендинга — при открытии и при каждой смене. Ошибку не показываем: это фон, лендинг работает и без неё.
 */
export function useSyncParticipantLanguage(): void {
  const { i18n } = useTranslation();
  const participantId = useMe().data?.participantId;
  const language = i18n.language;

  useEffect(() => {
    if (!participantId || !language || !LANGUAGE_CODES.includes(language as LanguageCode)) return;
    api.auth.saveLanguage({ language: language as LanguageCode }).catch((err: unknown) => {
      console.warn('[i18n] язык участника не сохранён', err);
    });
  }, [participantId, language]);
}
